import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

interface SideCardProps {
  title?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
}

export function SideCard({ title, icon, action, children, className, style, titleStyle }: SideCardProps) {
  return (
    <div className={cn('side-card', className)} style={style}>
      {title && (
        <div className="side-card-title" style={titleStyle}>
          {icon}
          <span>{title}</span>
          {action && <span className="sct-action">{action}</span>}
        </div>
      )}
      {children}
    </div>
  );
}

interface SideRowProps {
  label: ReactNode;
  value: ReactNode;
  mono?: boolean;
}

export function SideRow({ label, value, mono }: SideRowProps) {
  return (
    <div className="side-row">
      <span className="label">{label}</span>
      <span className={cn('value', mono && 'mono')}>{value}</span>
    </div>
  );
}

interface ActivityItemProps {
  tone?: 'default' | 'brand' | 'green' | 'amber';
  title: ReactNode;
  meta?: ReactNode;
}

export function ActivityItem({ tone = 'default', title, meta }: ActivityItemProps) {
  return (
    <div className={cn('activity-item', tone !== 'default' && tone)}>
      <div className="activity-dot" />
      <div className="activity-body">
        <div className="activity-title">{title}</div>
        {meta && <div className="activity-meta">{meta}</div>}
      </div>
    </div>
  );
}
